import { Chip, Dialog, DialogTitle, Divider, List, ListItemButton, Tooltip } from '@mui/material';
import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class ModalBuscaProcesso extends ReactComponent {
    handleClose = () => {
        this.observableProps.onClose(false);
    };

    abrirProcesso = (registro) => {
        this.handleClose();
        this.observableProps.callbackAbrirProcesso(registro);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleClose: action,
            abrirProcesso: action
        });
    }

    render() {
        if (!this.observableProps.open) {
            return null;
        }

        return (
            <Dialog
                onClose={this.handleClose}
                open={this.observableProps.open}
                maxWidth="md"
            >
                <DialogTitle id="simple-dialog-title">Busca de processos</DialogTitle>
                <Divider />
                <List>
                    {this.observableProps.processos.map((registro) => {
                        return (
                            <ListItemButton
                                divider
                                key={this.nextKey}
                                onClick={this.abrirProcesso.bind(this, registro)}
                                style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 24px' }}
                            >
                                <span style={{ minWidth: '450px' }}>{registro.processo.numeroCompleto}</span>
                                {registro.processo.relator ? (
                                    <Tooltip
                                        title={'Relator(a) ' + registro.processo.relator.nome}
                                        placement="top"
                                    >
                                        <Chip
                                            label={registro.processo.relator.sigla}
                                            style={{ height: '24px', fontSize: 12, margin: '0px 16px' }}
                                        />
                                    </Tooltip>
                                ) : (
                                    ''
                                )}
                                <span style={{ minWidth: '200px', display: 'flex', justifyContent: 'center' }}>
                                    {this.store.getDescricaoExibicaoProcesso(registro)}
                                </span>
                            </ListItemButton>
                        );
                    })}
                </List>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ModalBuscaProcesso));
